import routePaths from './routePaths.json';

export const ROUTES = Object.freeze(routePaths.pages);
export const UPDATE_NOTICE_PATHS = Object.freeze(routePaths.updateNotices);
